import { PROFILE } from "../../lib/data";
import { ArrowUpRight } from "lucide-react";

export const Footer = () => {
  return (
    <footer
      data-testid="footer"
      className="bg-[var(--ink)] text-[var(--paper)]"
    >
      <div className="max-w-[1480px] mx-auto px-5 md:px-10 py-16 md:py-24">
        <div className="grid grid-cols-12 gap-6 mb-14 md:mb-20 text-[10.5px] tracking-[0.22em] uppercase">
          <div className="col-span-6 md:col-span-3">
            <div className="opacity-50 mb-2">Based</div>
            <div>{PROFILE.location}</div>
          </div>
          <div className="col-span-6 md:col-span-3">
            <div className="opacity-50 mb-2">Phone</div>
            <a href={`tel:${PROFILE.phone.replace(/\s/g, "")}`} className="hover:opacity-60">
              {PROFILE.phone}
            </a>
          </div>
          <div className="col-span-6 md:col-span-3">
            <div className="opacity-50 mb-2">Email</div>
            <a
              href={`mailto:${PROFILE.email}`}
              data-testid="footer-email"
              className="hover:opacity-60 inline-flex items-center gap-1"
            >
              {PROFILE.email}
              <ArrowUpRight className="w-3 h-3" strokeWidth={1.5} />
            </a>
          </div>
          <div className="col-span-6 md:col-span-3">
            <div className="opacity-50 mb-2">Social</div>
            <a
              href={PROFILE.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-linkedin"
              className="hover:opacity-60 inline-flex items-center gap-1"
            >
              LinkedIn
              <ArrowUpRight className="w-3 h-3" strokeWidth={1.5} />
            </a>
          </div>
        </div>

        <h2 className="signature">
          Yash<br />Kankaria
          <span className="text-[var(--accent)]">.</span>
        </h2>

        <div className="mt-12 md:mt-16 hairline-t border-t border-white/20 pt-6 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-[10.5px] tracking-[0.22em] uppercase">
          <p className="opacity-70">
            Building businesses through memorable brands.
          </p>
          <p className="opacity-50">
            © {new Date().getFullYear()} · Yash Kankaria · The Portfolio №01
          </p>
        </div>
      </div>
    </footer>
  );
};
